import { Injectable } from '@angular/core';
import { GungModalService, NewsActionConfigService, NewsService } from 'gung-standard';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloNewsActionService extends NewsActionConfigService {
  constructor(protected gungModalService: GungModalService, protected newsService: NewsService) {
    super(gungModalService, newsService);
  }

  getIsEnabledShowUserNewsInPage(): Observable<boolean> {
    return of(true);
  }

  getIsEnabledShowUserNewsInModal(): Observable<boolean> {
    return of(true);
  }
}
